import { MenuItem } from '@mui/material'
import { ActionsItemProps } from './actions'
import { useSendToReview } from 'modules/orders/hooks'
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend'

export const SendToReview = ({ order, disabled }: ActionsItemProps) => {
  const { mutate, isLoading } = useSendToReview()

  const handleClick = () => {
    mutate({ proposalId: order?.proposalId })
  }

  return (
    <MenuItem
      disableRipple
      onClick={handleClick}
      disabled={isLoading || disabled}
    >
      <ScheduleSendIcon />
      Enviar para análise
    </MenuItem>
  )
}
